import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { compose } from 'recompose'

import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import { wizard, meta } from 'helpers/decorators'
import { Title, Button, FormDebug } from 'components/misc'
import { apiAwardUnits } from 'helpers/decorators/api'
import { ProfileFields } from 'containers/forms/participant'
import { participants } from 'constants/wizards'
import { isStepActive } from 'helpers/wizardHelper'

const enhance = compose(
  apiAwardUnits(),
  wizard({
    form: 'participantRegistration',
    multipage: true,
    destroyOnUnmount: false,
    validate: () => {}
  }),
  meta({
    title: 'Register participant',
    intlKey: 'pageTitle.register_participant'
  })
)

class Profile extends Component {
  static propTypes = {
    awardUnits: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    changeWizardNext: PropTypes.func,
    wizardSteps: PropTypes.array
  }

  handleSubmit = async fields => {
    const { rootPath, steps } = participants
    const step = isStepActive(this.props.wizardSteps, steps.payment.id) ? steps.payment : steps.account

    await this.props.changeWizardNext(steps.profile.id, rootPath + step.path)
    return this.props.onSubmit(fields)
  }

  render() {
    const { handleSubmit, awardUnits } = this.props

    const questions = get(awardUnits, 'questions')

    const pqDesc = get(this.props, 'values.helpers.profileQuestionsDesc')

    return (
      <form
        onSubmit={handleSubmit(this.handleSubmit)}
        data-testId="registrationProfileQuestionsForm"
      >
        <Title h1>
          <FormattedMessage
            id="moduleTitle.profile_questions"
            defaultMessage="Profile Questions"
          />
        </Title>

        <div className="row">
          <div className="col-xs-12 col-md-6">
            {pqDesc && <p style={{fontSize: 'initial'}}>
              <FormattedHTMLMessage
              id='label.profile_question_desc'
              defaultMessage={pqDesc}
              values={pqDesc}
            /></p>}
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-6">
            <ProfileFields parentalConsent={false} questions={questions} />
          </div>
        </div>

        <FormDebug {...this.props} />

        <Button>
          <FormattedMessage id="button.continue" defaultMessage="Continue" />
        </Button>
      </form>
    )
  }
}

export default enhance(Profile)
